/**
 * Parses ABV from sheet text. Empty/invalid → null. Valid numbers rounded to 1 decimal.
 */
export function normalizeAbv(rawAbv) {
  const trimmed = typeof rawAbv === 'string' ? rawAbv.trim() : String(rawAbv ?? '').trim();
  if (!trimmed) {
    return { abv: null, error: null };
  }

  const cleaned = trimmed.replace('%', '');
  const parsed = parseFloat(cleaned);
  if (!Number.isFinite(parsed)) {
    return { abv: null, error: `Invalid ABV "${rawAbv}"` };
  }

  const rounded = Math.round(parsed * 10) / 10;
  return { abv: rounded, error: null };
}
